import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { createBlogPost } from '../../../actions';
import BlogForm from './BlogForm';
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import compose from 'lodash/fp/compose';
import { withTranslation } from '../../hoc';
import Swal from 'sweetalert2';

const BlogCreateWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem;
`;

const BlogCreate = ({ tr }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getHtmlContent = (content) => {
    if (!content) return '';
    if (typeof content === 'string') return content;
    if (typeof content.getCurrentContent === 'function') {
      const contentState = content.getCurrentContent();
      return draftToHtml(convertToRaw(contentState));
    }
    return '';
  };

  const handleSubmit = async (formData, e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const htmlContent = getHtmlContent(formData.content);
      
      console.log('=== BlogCreate Submit Debug ===');
      console.log('Raw formData.content:', formData.content);
      console.log('Converted HTML:', htmlContent);
      console.log('HTML length:', htmlContent.length);
      
      if (!htmlContent.trim()) {
        Swal.fire(tr('Error'), tr('Content cannot be empty'), 'error');
        setIsSubmitting(false);
        return;
      }

      // Create FormData for submission
      const submitData = new FormData();
      submitData.append('title', formData.title);
      submitData.append('content', htmlContent); // Send as HTML string
      submitData.append('excerpt', formData.excerpt);
      submitData.append('category', formData.category);
      submitData.append('is_featured', formData.is_featured);
      submitData.append('meta_title', formData.meta_title || '');
      submitData.append('meta_description', formData.meta_description || '');

      const tagsArray = formData.tags.split(',').map(t => t.trim()).filter(t => t);
      submitData.append('tags', JSON.stringify(tagsArray));

      if (formData.featured_image instanceof File) {
        submitData.append('featured_image', formData.featured_image);
      }

      // Ensure status is valid (default to 'draft' if invalid)
      const validStatus = ['draft', 'published'].includes(formData.status) ? formData.status : 'draft';
      submitData.append('status', validStatus);

      await dispatch(createBlogPost(submitData));
      Swal.fire(tr('Success'), tr('Blog post created successfully'), 'success');
      navigate('/admin/dashboard/blog/posts');
    } catch (error) {
      console.error('Failed to create post:', error);
      Swal.fire(tr('Error'), tr('Failed to create blog post'), 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <BlogCreateWrapper>
      <h1>{tr('Create Blog Post')}</h1>
      <BlogForm
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        submitLabel={isSubmitting ? tr('Creating Post...') : tr('Create Post')}
      />
    </BlogCreateWrapper>
  );
};

export default compose(withTranslation)(BlogCreate);